import React from 'react'
import ReactDom from 'react-dom'
import coact from 'coact'

import models from './models'

// My Components
import RangeEditor from 'components/RangeEditor'
import PurchaseOrderEditor from 'components/PurchaseOrderEditor'
import SalesOrderEditor from 'components/SalesOrderEditor'
import SalesOrderReport from 'components/SalesOrderReport'
import SalesOrderDetail from 'components/SalesOrderDetail'
import CustExchanger from 'components/CustExchanger'
import UploadTemplate from 'components/UploadTemplate'

const config = {
  models,
  views: {},
  ui: {
    navbar: {
      title: '立勝光電',
    },
  },
  routes: [
    {
      path: '/edit/rangeEditor/:id',
      component: RangeEditor,
    },
    {
      path: '/edit/purchaseOrders/:id',
      component: PurchaseOrderEditor,
    },
    {
      path: '/edit/salesOrders/:id',
      component: SalesOrderEditor,
    },
    {
      path: '/export/salesOrders',
      component: SalesOrderDetail,
    },
    {
      path: '/export/salesOrderReport',
      component: SalesOrderReport,
    },
    {
      path: '/export/:name',
      component: CustExchanger,
    },
    {
      component: UploadTemplate,
      path: '/upload/template',
    },
  ],
}

const App = coact(config)

window.React = React
ReactDom.render(
  React.createElement(App),
  document.getElementById(config.mountDomId || 'app')
)



// WEBPACK FOOTER //
// ./src/client.js